import { LandingPage, type LandingPageProps } from "@components/marketing/LandingPage";
import { PrivacyPolicy, type PrivacyPolicyProps } from "@components/marketing/PrivacyPolicy";
import { TermsOfUse, type TermsOfUseProps } from "@components/marketing/TermsOfUse";
import {
  ExperimentalLandingPage,
  type ExperimentalLandingPageProps,
} from "@components/marketing-experimental/ExperimentalLandingPage";
import {
  FullLandingPage,
  type FullLandingPageProps,
} from "@components/marketing-original/FullLandingPage";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

function boot() {
  const simpleEl = document.getElementById("rarion-landing-root");
  if (simpleEl) {
    const props: LandingPageProps = JSON.parse(simpleEl.dataset.props || "{}");
    createRoot(simpleEl).render(
      <StrictMode>
        <LandingPage {...props} />
      </StrictMode>,
    );
    return;
  }

  const fullEl = document.getElementById("rarion-landing-full-root");
  if (fullEl) {
    const props: FullLandingPageProps = JSON.parse(fullEl.dataset.props || "{}");
    createRoot(fullEl).render(
      <StrictMode>
        <FullLandingPage {...props} />
      </StrictMode>,
    );
    return;
  }

  const experimentalEl = document.getElementById("rarion-landing-experimental-root");
  if (experimentalEl) {
    const props: ExperimentalLandingPageProps = JSON.parse(experimentalEl.dataset.props || "{}");
    createRoot(experimentalEl).render(
      <StrictMode>
        <ExperimentalLandingPage {...props} />
      </StrictMode>,
    );
    return;
  }

  const privacyEl = document.getElementById("rarion-privacy-root");
  if (privacyEl) {
    const props: PrivacyPolicyProps = JSON.parse(privacyEl.dataset.props || "{}");
    createRoot(privacyEl).render(
      <StrictMode>
        <PrivacyPolicy {...props} />
      </StrictMode>,
    );
    return;
  }

  const termsEl = document.getElementById("rarion-terms-root");
  if (termsEl) {
    const props: TermsOfUseProps = JSON.parse(termsEl.dataset.props || "{}");
    createRoot(termsEl).render(
      <StrictMode>
        <TermsOfUse {...props} />
      </StrictMode>,
    );
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
